<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" *ngIf="showSpinner" id="loading-spinner"></fab-loading-spinner>

<h1 class="title">Manage Transmission Attributes</h1>
<span class="header-spacing"></span>
<button mat-raised-button color="primary" id="reset-button" class="reset-button"
        (click)="resetOptions()">
  Reset Filters
</button>
<div>
  <mat-form-field class="select" appearance="fill"
                  (click)="resetText(family)">
    <mat-label>Trans Family</mat-label>
    <input type="text" id="family-input"
           [placeholder]="ALL"
           matInput
           [formControl]="this.family.form"
           [matAutocomplete]="autoFamily"/>
    <mat-autocomplete #autoFamily="matAutocomplete" (optionSelected)="onChangeSelection('TRANFAM', family)">
      <mat-option *ngFor="let family of this.family.filteredOptions | async" [value]="family">{{family}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-raised-button color="primary" class="edit-button"
          [disabled]="family.selectedOption === ALL || family.selectedOption === '%'"
          (click)="openDialog('Trans Family', family.selectedOption,
           'TRANFAM')">
    Edit
  </button>

  <mat-form-field class="select" appearance="fill"
                  (click)="resetText(rpo)">
    <mat-label>Trans RPO</mat-label>
    <input type="text" id="rpo-input"
           [placeholder]="ALL"
           matInput
           [formControl]="this.rpo.form"
           [matAutocomplete]="autoRpo"/>
    <mat-autocomplete #autoRpo="matAutocomplete" (optionSelected)="onChangeSelection('TRANRPO', rpo)">
      <mat-option *ngFor="let rpo of this.rpo.filteredOptions | async" [value]="rpo">{{rpo}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field class="select" appearance="fill"
                  (click)="resetText(name)">
    <mat-label>Trans Name</mat-label>
    <input type="text" id="name-input"
           [placeholder]="ALL"
           matInput
           [formControl]="this.name.form"
           [matAutocomplete]="autoName"/>
    <mat-autocomplete #autoName="matAutocomplete" (optionSelected)="onChangeSelection('TRANSMISSIONNAME', name)">
      <mat-option *ngFor="let name of this.name.filteredOptions | async" [value]="name">{{name}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field class="select" appearance="fill"
                  (click)="resetText(transmissionType)">
    <mat-label>Trans Type</mat-label>
    <input type="text" id="transtype-input"
           [placeholder]="ALL"
           matInput
           [formControl]="this.transmissionType.form"
           [matAutocomplete]="autoTransType"/>
    <mat-autocomplete #autoTransType="matAutocomplete" (optionSelected)="onChangeSelection('TRANTYPE', transmissionType)">
      <mat-option *ngFor="let transmissionType of this.transmissionType.filteredOptions | async"
                  [value]="transmissionType">{{transmissionType}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>
</div>

<div>
  <mat-form-field class="select" appearance="fill"
                  (click)="resetText(speed)">
    <mat-label>Trans Speed</mat-label>
    <input type="text" id="speed-input"
           [placeholder]="ALL"
           matInput
           [formControl]="this.speed.form"
           [matAutocomplete]="autoSpeed"/>
    <mat-autocomplete #autoSpeed="matAutocomplete" (optionSelected)="onChangeSelection('TRANSPEED', speed)">
      <mat-option *ngFor="let speed of this.speed.filteredOptions | async" [value]="speed">{{speed}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <span class="spacing"></span>

  <mat-form-field class="select" appearance="fill"
                  (click)="resetText(driveType)">
    <mat-label>Drive Type</mat-label>
    <input type="text" id="drive-type-input"
           [placeholder]="ALL"
           matInput
           [formControl]="this.driveType.form"
           [matAutocomplete]="autoDriveType"/>
    <mat-autocomplete #autoDriveType="matAutocomplete" (optionSelected)="onChangeDriveType()">
      <mat-option *ngFor="let driveType of this.driveType.filteredOptions | async"
                  [value]="driveType">{{driveType}}</mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <button mat-raised-button color="primary" class="edit-button"
          [disabled]="driveType.selectedOption === ALL || driveType.selectedOption === '%'"
          (click)="openDialog('Drive Type', driveType.selectedOption,
           'DRIVETYPE')">
    Edit
  </button>

</div>
